import { render, staticRenderFns } from "./ReportesCapacitacion.vue?vue&type=template&id=00c4954c"
import script from "./ReportesCapacitacion.vue?vue&type=script&lang=js"
export * from "./ReportesCapacitacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports